module.exports = __webpack_public_path__ + "static/media/05-kittel_brille.ce7fb9b3.jpg";